<template>
  <q-btn
    ref="target"
    flat
    size="md"
    no-wrap
    color="secondary"
    @click="open=!open"
    class="q-caption"
    :label="`${value.length} ${column.field}`"
  >
    <q-popover v-model="open">
      <q-list separator link>
        <q-item
          v-for="(item, index) in value"
          :key="index"
          v-close-overlay
          class="text-truncate q-caption"
        >
          <q-item-main
            :label="item.name"
            :subtitle="item.contactType"
          />
        </q-item>
      </q-list>
    </q-popover>
  </q-btn>
</template>
<script>
export default {
  name: 'GridCellRepeat',
  props: {
    column: Object,
    row: Object,
    clientRoute: String,
    resource: String,
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    /** Helpers **/
    parentId () {
      return this.id ? parseInt(this.id) : null
    },
    valueFk () {
      return this.repeat ? this.repeat.valueFk : null
    },
    repeat () {
      return this.column.repeat
    },
    repeatLabel () {
      return this.repeat ? this.repeat.label : 'id'
    },
    repeatColumn () {
      return this.repeat ? this.repeat.column : null
    },
    repeatResource () {
      return this.repeat ? this.repeat.namespace : null
    }
  }
}
</script>
